import styles from "./MembersItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "shared/Button";

/**
 *
 * Displays information about an admin in the admin list.
 */

export function MembersItem({ memberInfo, onClick, empty }) {
  return (
    <div className={classNames(styles.container)}>
      <div className={styles.item}>{memberInfo.iboName}</div>
      <div className={styles.item}>{memberInfo.iboNum}</div>

      {!empty ? (
        <>
          <div className={styles.item}>{memberInfo.pluginId}</div>
          <div className={styles.item}>
            {memberInfo.asAdmin ? "True" : "False"}
          </div>
          <div className={styles.item}>{memberInfo.pluginType}</div>
        </>
      ) : (
        <>
          <div></div>
          <div></div>
          <div></div>
        </>
      )}

      <div className={styles.item}>
        <Button className={styles.detailsBtn} onClick={onClick} size="small">
          Details
        </Button>
      </div>
    </div>
  );
}

MembersItem.propTypes = {
  empty: PropTypes.bool,
  onClick: PropTypes.func,
  memberInfo: PropTypes.object,
};
